export default __webpack_public_path__ + "static/media/carretRight.94951575.svg";